import { DefaultRootState } from 'react-redux';

import selectFilteredProductsByCustomer from '../../../../selectors/select-filtered-products-by-customer';

const getSelector = (productIds: string[] | undefined, state: DefaultRootState) => {
  if (!productIds) return null;
  return selectFilteredProductsByCustomer(state, { match: { params: { productIds } } });
};

export default getSelector;
